/* global __MODULE_SETTINGS__ */
import { isEmpty } from "@common/util";

/**
 * __MODULE_SETTINGS__ is injected by webpack.DefinePlugin at build time (see
 * webpack.config.js), sourced from proto-cloud/module-catalog's generated
 * modules.<domain>.json. It is a compiled-in constant, not a runtime fetch —
 * a claimcolony build and a cche build are two different bundles.
 *
 * Fails open (returns true) when the key is absent from the resolved
 * document — same convention as getNavOldStatus() in common/util.js, so an
 * unbuilt domain file (MODULES_FILE unset) or a brand-new catalog key with
 * no override anywhere never hides something that used to be visible.
 */
export const isModuleEnabled = (modules, key) => {
  if (isEmpty(modules)) return true;
  const value = modules[key];
  return value === undefined ? true : Boolean(value);
};

export const moduleLabel = (labels, key, fallback) => {
  if (isEmpty(labels) || labels[key] === undefined) return fallback;
  return labels[key];
};

/**
 * useModules().isModuleEnabled('diaries') — mirrors the getNavItem/getNavOldStatus
 * idiom already used for cc_navigation. Not actually a React hook (no state,
 * no subscription) — kept as a `use*` function so call sites read the same
 * as before and nothing downstream needs to change if this ever does need
 * to become reactive.
 */
export const useModules = () => {
  const modules = __MODULE_SETTINGS__.modules;
  const labels = __MODULE_SETTINGS__.labels;

  return {
    domain: __MODULE_SETTINGS__.domain,
    version: __MODULE_SETTINGS__.checksum,
    isModuleEnabled: (key) => isModuleEnabled(modules, key),
    moduleLabel: (key, fallback) => moduleLabel(labels, key, fallback),
  };
};
